export const NAME = 'shoppingCompleted';